<template>
    <div>

        <vue-headful title="Jobsite Import :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/jobsites`">
                        <i class="fa fa-building"></i> Jobsites
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    Import
                </li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <template v-if="loading">
                    <i class="fa fa-circle-o-notch fa-spin"></i> Loading
                </template>
                <template v-else>
                    <div v-if="Object.keys(divisions).length == 0">
                        <div class="alert alert-warning">
                            <strong>Cannot Import Jobsites:</strong> You do not have any divisions setup. You must have at least 1 Division to import Jobsites.<br/>
                            Go to <router-link :to="`/admin/divisions`">Division Settings</router-link> under the Admin tab to add a Division.
                        </div>
                    </div>
                    <div v-else>
                        <div class="alert alert-success">
                            File must be a CSV with the first row containing the columns names in this <a href="/documents/JobsitesImportTemplate.csv" target="_blank">Template</a>
                        </div>
                        <div v-bind:class="{ 'form-group': true, 'has-error': errors.files }" class="row">
                            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Files</label>
                            <div class="col-sm-8">

                                <b-form-file v-model="file" class="mt-3" plain></b-form-file>

                                <span v-if="errors.files" class="text-danger">
                                    <span v-for="error in errors.files">{{ error }}</span>
                                </span>
                            </div>
                        </div>

                        <div v-bind:class="{'has-error': errors.files }" class="row form-group">
                            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Deactivate Jobsites?</label>
                            <div class="col-sm-8">

                                <b-form-checkbox v-model="deactivate_jobsites" :value="true" :unchecked-value="false" plain> Checking this box will deactivate ALL jobsites not found on the provided spreadsheet above.</b-form-checkbox>

                                <span v-if="errors.files" class="text-danger">
                                    <span v-for="error in errors.files">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-success" @click="importFile" :disabled="saving" v-if="Object.keys(divisions).length > 0">
                    Import File <i class="fa fa-spinner fa-spin" v-if="saving"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                deactivate_jobsites: false,
                file: [],
                errors: {},
                divisions: {},
            }
        },

        methods: {
            //Gets resources for import
            getImport(){
                //Send it
                this.$http.get('jobsites/import')
                    .then(res => {
                        //Set the data
                        this.divisions = res.data.divisions;
                    })
                    .then(res => {
                        //Activate
                        this.loading = false;
                    });
            },

            importFile() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .postWithFiles('jobsites/import', {deactivate_jobsites: this.deactivate_jobsites}, [this.file])
                .then(response => {
                    this.$toastr.success('Jobsites Imported');

                    //Return to main list?
                    this.$router.push('/jobsites');

                    //Refresh the Alerts
                    this.$root.getAlerts();
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    else
                    {
                        this.$toastr.error(error.response.data, 'Failed to Import CSV');
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get resources
            this.getImport();
        }
    }
</script>
